import React from 'react';
import { motion } from 'framer-motion';
import { BookMockup } from './BookMockup';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Bonuses() {
  return <section id="bonos" className="py-24 bg-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-29">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-30">
          <motion.h2 className="text-4xl font-serif text-charcoal mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-31">
            Además, te llevas 3 bonos prácticos
          </motion.h2>
          <motion.p className="text-lg text-warmGray" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-32">
            Dos recursos diseñados para ayudarte desde el primer día.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-33">
          {/* Bonus 1 */}
          <motion.div className="bg-sand/30 rounded-3xl p-8 lg:p-10 border border-sand flex flex-col sm:flex-row gap-8 items-center sm:items-start" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-34">
            <div className="shrink-0 relative" data-id="element-35">
              <div className="absolute -top-3 -right-3 bg-mauve text-white text-[10px] font-bold uppercase tracking-wider py-1 px-3 rounded-full z-20 shadow-sm" data-id="element-36">
                Bono Incluido
              </div>
              <BookMockup title="Plan Semanal" subtitle="de Introducción" variant="bonus1" size="sm" data-id="element-37" />
            </div>

            <div className="space-y-4 text-center sm:text-left" data-id="element-38">
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-39">
                Plan Semanal de Introducción
              </h3>
              <div className="flex items-center gap-2" data-id="element-40">
                <span className="text-sm text-warmGray/60 line-through" data-id="element-41">
                  $14.99
                </span>
                <span className="text-sm font-bold text-olive" data-id="element-42">
                  GRATIS con tu compra
                </span>
              </div>
              <p className="text-warmGray text-sm leading-relaxed" data-id="element-43">
                Una hoja de ruta simple y flexible para los primeros 7 días de
                alimentación complementaria. Ideal para empezar sin presión, con
                orden y con ideas claras.
              </p>
              <ul className="space-y-2 pt-2 text-left" data-id="element-44">
                {['Día a día sugerido', 'Porciones pequeñas y progresivas', 'Introducción suave de sabores', 'Primeros pasos con hierro, vegetales, huevo y legumbres', 'Recordatorios para mantener la calma'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-charcoal" data-id="element-45">
                    <Check className="w-4 h-4 text-sage shrink-0 mt-0.5" data-id="element-46" />
                    <span data-id="element-47">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div className="bg-sand/30 rounded-3xl p-8 lg:p-10 border border-sand flex flex-col sm:flex-row gap-8 items-center sm:items-start" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-48">
            <div className="shrink-0 relative" data-id="element-49">
              <div className="absolute -top-3 -right-3 bg-mauve text-white text-[10px] font-bold uppercase tracking-wider py-1 px-3 rounded-full z-20 shadow-sm" data-id="element-50">
                Bono Incluido
              </div>
              <BookMockup title="La Despensa" subtitle="Consciente" variant="bonus2" size="sm" data-id="element-51" />
            </div>

            <div className="space-y-4 text-center sm:text-left" data-id="element-52">
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-53">
                La Despensa Consciente
              </h3>
              <div className="flex items-center gap-2" data-id="element-54">
                <span className="text-sm text-warmGray/60 line-through" data-id="element-55">
                  $12.99
                </span>
                <span className="text-sm font-bold text-olive" data-id="element-56">
                  GRATIS con tu compra
                </span>
              </div>
              <p className="text-warmGray text-sm leading-relaxed" data-id="element-57">
                Tu lista de compras lista para usar, enfocada en los nutrientes
                más importantes al comenzar esta etapa.
              </p>
              <ul className="space-y-2 pt-2 text-left" data-id="element-58">
                {['Base de hierro y zinc', 'Grasas saludables', 'Verduras y frutas variadas', 'Cereales integrales simples', 'Trucos prácticos y alimentos que conviene evitar'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-charcoal" data-id="element-59">
                    <Check className="w-4 h-4 text-sage shrink-0 mt-0.5" data-id="element-60" />
                    <span data-id="element-61">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
          {/* Bonus 3 */}
          <motion.div className="bg-sand/30 rounded-3xl p-8 lg:p-10 border border-sand flex flex-col sm:flex-row gap-8 items-center sm:items-start lg:col-span-2 lg:max-w-2xl lg:mx-auto" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-62">
            <div className="shrink-0 relative" data-id="element-63">
              <div className="absolute -top-3 -right-3 bg-mauve text-white text-[10px] font-bold uppercase tracking-wider py-1 px-3 rounded-full z-20 shadow-sm" data-id="element-64">
                Bono Incluido
              </div>
              <BookMockup title="30 Recetas" subtitle="Esenciales" variant="bonus3" size="sm" data-id="element-65" />
            </div>

            <div className="space-y-4 text-center sm:text-left" data-id="element-66">
              <h3 className="text-2xl font-serif text-charcoal" data-id="element-67">
                Primeros Bocados: 30 Recetas Esenciales
              </h3>
              <div className="flex items-center gap-2" data-id="element-68">
                <span className="text-sm text-warmGray/60 line-through" data-id="element-69">
                  $19.99
                </span>
                <span className="text-sm font-bold text-olive" data-id="element-70">
                  GRATIS con tu compra
                </span>
              </div>
              <p className="text-warmGray text-sm leading-relaxed" data-id="element-71">
                Recetas densas en nutrientes, sin sal ni azúcar añadida,
                diseñadas para cubrir hierro, zinc y grasas saludables en cada
                bocado. Para bebés de 6 a 12 meses.
              </p>
              <ul className="space-y-2 pt-2 text-left" data-id="element-72">
                {['30 recetas nutritivas y fáciles de preparar', 'Sin sal ni azúcar añadida', 'Ricas en hierro, zinc y grasas saludables', 'Adaptadas para bebés de 6 a 12 meses', 'Opciones para BLW, papillas y alimentación combinada'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-charcoal" data-id="element-73">
                    <Check className="w-4 h-4 text-sage shrink-0 mt-0.5" data-id="element-74" />
                    <span data-id="element-75">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div className="text-center mt-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-76">
          <a href="https://epikkastore.com/cart/45054208213015:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-olive hover:bg-olive/90 text-white px-10 py-4 rounded-lg font-medium transition-colors shadow-sm text-lg inline-block text-center" data-id="element-77">
            Comprar ahora
          </a>
        </motion.div>
      </div>
    </section>;
}